import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, errMsg, eur, serviceAmount } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CatalogTable } from "@/components/admin/CatalogTable";

const KIND = { video: "Video consulto", domicilio: "A domicilio", visita: "Visita in presenza" };
const TYPES = [["fissa", "Fissa"], ["oraria", "Oraria"], ["forfettaria", "Forfettaria"]];

function PriceRow({ s, onSaved }) {
  const [f, setF] = useState({ price: s.price, pricing_type: s.pricing_type || "fissa" });
  const dirty = Number(f.price) !== s.price || f.pricing_type !== (s.pricing_type || "fissa");
  const save = () => api.put(`/admin/services/${s.id}/pricing`, { price: Number(f.price), pricing_type: f.pricing_type })
    .then(() => { toast.success(`Tariffa aggiornata: ${s.name}`); onSaved(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <tr className="border-t border-slate-100" data-testid={`pricing-row-${s.id}`}>
      <td className="px-3 py-2"><b className="text-slate-800">{s.name}</b><span className="block text-[11px] text-slate-500">{KIND[s.kind] || s.kind} · {s.duration_min} min{!s.active && " · non attiva"}</span></td>
      <td className="px-3 py-2">
        <Select value={f.pricing_type} onValueChange={(v) => setF({ ...f, pricing_type: v })}>
          <SelectTrigger className="h-9 w-36" data-testid={`pricing-type-${s.id}`}><SelectValue /></SelectTrigger>
          <SelectContent>{TYPES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </td>
      <td className="px-3 py-2"><div className="flex items-center gap-1"><span className="text-slate-400">€</span><Input data-testid={`pricing-price-${s.id}`} type="number" min={0} step="0.5" value={f.price} onChange={(e) => setF({ ...f, price: e.target.value })} className="h-9 w-24" />{f.pricing_type === "oraria" && <span className="text-[11px] text-slate-500">/ora</span>}</div></td>
      <td className="px-3 py-2 font-mono text-xs text-slate-700" data-testid={`pricing-total-${s.id}`}>{eur(serviceAmount({ ...s, ...f, price: Number(f.price) }))}</td>
      <td className="px-3 py-2 text-right"><Button size="sm" disabled={!dirty} data-testid={`pricing-save-${s.id}`} onClick={save} className="bg-emerald-600 hover:bg-emerald-700"><Save className="mr-1 h-3.5 w-3.5" />Salva</Button></td>
    </tr>
  );
}

export function ServicePricing({ onChange }) {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/catalog/services").then(({ data }) => setItems(data));
  useEffect(() => {
    load();
  }, []);
  return (
    <div className="space-y-2" data-testid="service-pricing">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">Tariffe delle prestazioni esistenti</p>
      <p className="text-xs text-slate-500">Fissa o forfettaria: il paziente paga l'importo indicato. Oraria: tariffa × durata della prestazione. Le prenotazioni già fatte mantengono il loro prezzo.</p>
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-50 text-xs text-slate-500"><tr><th className="px-3 py-2">Prestazione</th><th className="px-3 py-2">Tipo tariffa</th><th className="px-3 py-2">Tariffa</th><th className="px-3 py-2">Prezzo al paziente</th><th /></tr></thead>
          <tbody>{items.map((s) => <PriceRow key={`${s.id}-${s.price}-${s.pricing_type}`} s={s} onSaved={() => { load(); onChange?.(); }} />)}</tbody>
        </table>
      </div>
    </div>
  );
}

export function ServicesAdmin() {
  const [v, setV] = useState(0);
  return (
    <div className="space-y-8">
      <ServicePricing key={`p-${v}`} onChange={() => setV((n) => n + 1)} />
      <div><p className="mb-2 text-xs font-bold uppercase tracking-[0.18em] text-slate-500">Catalogo completo</p><CatalogTable key={`c-${v}`} collection="services" onChange={() => setV((n) => n + 1)} /></div>
    </div>
  );
}
